module.exports = "images/homepage.5669cff2.png";